import CalendariumListPage from './CalendariumListPage';

export default CalendariumListPage;
